import { render, staticRenderFns } from "./Sitemap.vue?vue&type=template&id=379069fa&scoped=true"
import script from "./Sitemap.vue?vue&type=script&lang=js"
export * from "./Sitemap.vue?vue&type=script&lang=js"
import style0 from "./Sitemap.vue?vue&type=style&index=0&id=379069fa&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379069fa",
  null
  
)

export default component.exports